<template>
  <div class="menu-wrapper">
    <v-list dense>
      <v-list-tile v-if="user.subscription === 'extensive'" to="/">
        <v-list-tile-action>
          <v-icon>fa-tachometer-alt</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            {{ $t('message.dashboard_monitor') }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-if="user.subscription === 'extensive'"
        :to="{ name: 'indicatorslist' }"
      >
        <v-list-tile-action>
          <v-icon>fa-clipboard-list</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            {{ $t('message.indicator_list') }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-if="user.subscription === 'extensive'"
        :to="{ name: 'targets', params: { targetId: 'own' } }"
      >
        <v-list-tile-action>
          <v-icon>fa-bullseye</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('message.targets') }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile v-if="user.subscription !== 'student'" href="/forum">
        <v-list-tile-action>
          <v-icon>fa-comments</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('message.forum') }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile href="https://omdatlevensduurloont.nl" target="_blank">
        <v-list-tile-action>
          <v-icon>fa-book-open</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('message.manual') }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile :to="{ name: 'profile' }">
        <v-list-tile-action>
          <v-icon>fa-user</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('message.profile') }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <div class="subscription-text">
      {{ $t('message.user_subscription') }}:<br />
      {{ $t('message.user_subscription_' + user.subscription) }}
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'UserMenu',
  computed: {
    ...mapState(['user']),
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
    },
  },
}
</script>
<style>
.menu-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 48px);
}
.subscription-text {
  color: white;
  padding: 0 0 10px 15px;
}
.v-list--dense .v-list__tile {
  font-weight: 500;
}
</style>
